// Public walkthrough. Example screens from a test job. Not linked from other pages.

export const HOW_A_JOB_WORKS = {
  path: '/how-it-works',
  title: 'How a job works — The WasteGame',
  description:
    'Example screens from a test job on The WasteGame: a customer posts, a carrier sends a price, the customer accepts, and a waste transfer note is saved. The payment panel is a mock-up.',
  h1: 'How a job works',
  intro:
    'These are example screens from a test job. They show the order a job follows on The WasteGame. Free for customers to post a job.',
  notes: [
    'Test accounts and test job. Example screens only.',
    'Licence number shown is a test placeholder.',
  ],
  steps: [
    {
      n: '1',
      title: 'Customer posts a job (free).',
      text: 'Test Customer Sketty picks a service and adds the postcode, a description and a date.',
      src: '/how-it-works/step-01.png',
      alt: 'Example screen of a test customer posting a job',
    },
    {
      n: '2',
      title: 'Carriers in the area see it.',
      text: 'Bay Test Clearances sees the new job under Open Jobs and can tap Bid Now.',
      src: '/how-it-works/step-02.png',
      alt: 'Example screen of a test carrier viewing an open job',
    },
    {
      n: '3',
      title: 'A carrier sends a price (bid).',
      text: 'Bay Test Clearances offers £35 with an ETA and a short note.',
      src: '/how-it-works/step-03.png',
      alt: 'Example screen of a test carrier sending a price',
    },
    {
      n: '4',
      title: 'Customer picks a bid and accepts.',
      text: 'The bid shows the price, the ETA and the carrier’s details.',
      src: '/how-it-works/step-04.png',
      alt: 'Example screen of a customer accepting a test bid',
    },
    {
      n: '5',
      title: 'Track the job live.',
      text: 'Status steps update as the job moves along, and the customer and carrier can message.',
      src: '/how-it-works/step-05.png',
      alt: 'Example screen of live tracking for a test job',
    },
    {
      n: '6',
      title: 'Job complete: waste transfer note saved.',
      text: 'A waste transfer note is saved to the customer’s account and can be printed.',
      src: '/how-it-works/step-06.png',
      alt: 'Example screen of a saved waste transfer note for a test job',
    },
    {
      n: '7',
      title: 'Payment (mock-up).',
      text: 'Example only: this panel is a mock-up showing where payment would happen. Mock-up. No real payment taken.',
      src: '/how-it-works/step-07.png',
      alt: 'Mock-up payment panel. No real payment taken.',
    },
  ],
};
